import React from 'react';
import {withTranslation} from "react-i18next";

let FormErrorComponent = ({messageKey, t}) => {
    return <div className="row error-container form-error">
        <div className="col-2">
            <span className="exclamation-sign"></span>
        </div>
        <div className="col-10 align-self-center">
            {t(messageKey)}
        </div>

    </div>;
};

export default withTranslation()(FormErrorComponent)